import { useContext, useEffect, useState } from "react";
import Layout from "../../Component/layout/main-layout";
import { GetCodexTable } from "../../api/Queries/get";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loading from "../../Component/loader/loader";
import { Context } from "../../Store/context";
import layoutBgImg from "../../Images/layout/laws.png";

const CodexTable = () => {
  const location = useLocation().pathname.split("/")[2];
  const [codex, setCodex] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { i18n, t } = useTranslation();
  const { showError } = useContext(Context);

  useEffect(() => {
    const getCodex = async () => {
      setIsLoading(true);

      try {
        const res = await GetCodexTable(location);
        setCodex(res?.data || null);
      } catch (error) {
        showError(error?.message || "Maglumat ýüklenmedi");
      } finally {
        setIsLoading(false);
      }
    };

    if (location) {
      getCodex();
    }
  }, [location, showError]);

  const getLawPdf = (laws) => {
    if (!laws) return "";
    const currentLang = i18n.language;
    if (currentLang === "ru") {
      return laws.rus_pdf || laws.tm_pdf || "";
    }
    if (currentLang === "en") {
      return laws.eng_pdf || laws.tm_pdf || "";
    }
    return laws.tm_pdf || "";
  };

  const pdf = getLawPdf(codex);

  return (
    <div className="mb-20">
      <Layout
        title={t("laws_codes")}
        page={t("tm_codex")}
        layoutBgImg={layoutBgImg}
      />

      <main className="media">
        <div
          className="bg-white border border-secondary 
                     dark:border-dark-border mt-8 p-2 w-full
                     dark:bg-dark-box dark:text-dark-text"
        >
          {isLoading ? (
            <Loading />
          ) : pdf ? (
            <div className="h-[1000px] max-h-max">
              <iframe
                src={`${pdf}#toolbar=0&navpanes=0&view=FitH`}
                className="w-full h-full"
                frameBorder="0"
                title="PDF Viewer"
              />
            </div>
          ) : (
            <p className="text-center">PDF tapylmady</p>
          )}
        </div>
      </main>
    </div>
  );
};

export default CodexTable;